<div class="page-container">
  <div class="stats-page">
    <mat-toolbar class="cdc-header">
      <span>{{ 'Stats' | translate }}</span>

      <div class="d-flex flex-row align-items-center gap-2">
        <button mat-stroked-button class="cdc-button" (click)="onExportStats()">
          <mat-icon>file_download</mat-icon>
          <span>{{'Export' | translate}}</span>
        </button>
        <button mat-stroked-button class="cdc-button" (click)="applyFilter()">
          <mat-icon>refresh</mat-icon>
          <span>{{'Refresh' | translate}}</span>
        </button>
        <button mat-stroked-button class="cdc-button" (click)="applyFilter(true)">
          <mat-icon>filter_alt_off</mat-icon>
          <span>{{'Reset' | translate}}</span>
        </button>
      </div>
    </mat-toolbar>
    <div class="div-table ">
      <div class="mat-elevation-z8 col-11 col-lg-11 col-md-11 m-3">
        <div class="table-container">

          <table mat-table
                 [dataSource]="dataSource"
                 matSort
                 class="custom-table">
            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
              <!-- HEADER: TITLE -->
              <th mat-header-cell *matHeaderCellDef class="header-cell">{{ columnLabels[col] }}</th>
              <!-- CELL -->
              <td mat-cell *matCellDef="let stat">
                <span
                    class="cell-ellipsis"
                    tooltipTruncate
                    [matTooltip]="formatCellValue(col, stat[col])">
                    {{ formatCellValue(col, stat[col]) }}
                  </span>
              </td>
            </ng-container>

            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col + '_filter'">
              <th mat-header-cell *matHeaderCellDef class="filter-cell">
                <ng-container *ngIf="getFilter(col) as filter">

                  <!-- SELECT FILTER -->
                  <ng-container *ngIf="filter.type === ComponentType.SELECT">
                    <div class="cdc-form-field m-0 actif">
                      <mat-form-field class="d-flex flex-column select-container">
                        <mat-select [ngModel]="activeFilters[col]?.values ?? []" (ngModelChange)="onSelectFilter(col, $event)" multiple placeholder="{{ 'Select' | translate }}">
                          <mat-option *ngFor="let option of filter.options" [value]="option.label">{{ formatFilterValue(col, option.label) | translate }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </ng-container>

                  <!-- TEXT FILTER -->
                  <ng-container *ngIf="filter.type === ComponentType.INPUT">
                    <div class="cdc-form-field m-0 actif">
                      <input #filterInput matInput type="text" (keyup)="onTextFilter(col, $event)" placeholder="{{ 'Search' | translate }}">
                    </div>
                  </ng-container>

                </ng-container>
              </th>
            </ng-container>

            <!-- TITLES ROW -->
            <tr mat-header-row class="displayedColumns" *matHeaderRowDef="displayedColumns"></tr>
            <!-- FILTERS ROW -->
            <tr mat-header-row class="filterColumns" *matHeaderRowDef="filterColumns"></tr>
            <!-- DATA -->
            <tr mat-row *matRowDef="let stat; columns: displayedColumns" class="table-row"></tr>
            <!-- NO DATA -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="99">
                {{ 'No items to display' | translate }}
              </td>
            </tr>
          </table>

        </div>

        <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"
          [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </div>

  </div>
</div>
